function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#F2EFDC;}\r\n\t.st2{fill:#ED6F46;}\r\n\t.st3{fill:#343F4E;}\r\n\t.st4{fill:none;stroke:#343F4E;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st5{fill:#ED6F46;stroke:#343F4E;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st6{fill:#ED6F46;stroke:#343F4E;stroke-width:2.2909;stroke-linecap:round;stroke-miterlimit:10;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "272.3,33.8 268.5,33.9 272.3,33.9  "
}), React.createElement("path", {
  className: "st1",
  d: "M121.8,86.1c6,3.9,20.4,5.9,43.5,6.9c1.1,0.1,2.8,1.7,6.9,1.7c4,0,3.8-3.3,4.7-3.3 c44.9,1.6,137.3,0.3,137.3,0.3s0.5,2.9,5.7,2.9s5.9-0.9,5.9-0.9l19.9-3.7c0,0,1.9-15-4.3-28.2c-2-2.3-23.1-8.9-25.2-11.2 c-12-13.3-26-26.7-39.3-33.7c-8.4-1.6-138.1-3.4-146.4-1.6C122.2,17.1,120.1,82.7,121.8,86.1z"
}), React.createElement("g", null, React.createElement("rect", {
  x: 12.3,
  y: 31.1,
  className: "st2",
  width: 24.7,
  height: 17.8
}), React.createElement("rect", {
  x: 39.2,
  y: 31.1,
  className: "st2",
  width: 24.2,
  height: 17.8
}), React.createElement("rect", {
  x: 39,
  y: 31.1,
  className: "st2",
  width: 0.2,
  height: 17.8
}), React.createElement("rect", {
  x: 65.9,
  y: 31.1,
  className: "st2",
  width: 24.4,
  height: 17.8
}), React.createElement("rect", {
  x: 65.4,
  y: 31.1,
  className: "st2",
  width: 0.5,
  height: 17.8
}), React.createElement("rect", {
  x: 12.3,
  y: 50.8,
  className: "st2",
  width: 24.7,
  height: 17.6
}), React.createElement("rect", {
  x: 39.2,
  y: 50.8,
  className: "st2",
  width: 24.2,
  height: 17.6
}), React.createElement("rect", {
  x: 39,
  y: 50.8,
  className: "st2",
  width: 0.3,
  height: 17.6
}), React.createElement("rect", {
  x: 65.9,
  y: 50.8,
  className: "st2",
  width: 24.4,
  height: 17.6
}), React.createElement("rect", {
  x: 65.4,
  y: 50.8,
  className: "st2",
  width: 0.5,
  height: 17.6
}), React.createElement("rect", {
  x: 12.3,
  y: 70.6,
  className: "st2",
  width: 24.7,
  height: 17.6
}), React.createElement("rect", {
  x: 12.3,
  y: 70.4,
  className: "st2",
  width: 24.7,
  height: 0.2
}), React.createElement("rect", {
  x: 39.2,
  y: 70.6,
  className: "st2",
  width: 24.2,
  height: 17.6
}), React.createElement("rect", {
  x: 39.2,
  y: 70.4,
  className: "st2",
  width: 24.2,
  height: 0.2
}), React.createElement("rect", {
  x: 39,
  y: 70.6,
  className: "st2",
  width: 0.2,
  height: 17.6
}), React.createElement("rect", {
  x: 39,
  y: 70.4,
  className: "st2",
  width: 0.2,
  height: 0.2
}), React.createElement("rect", {
  x: 65.9,
  y: 70.6,
  className: "st2",
  width: 24.4,
  height: 17.6
}), React.createElement("rect", {
  x: 65.9,
  y: 70.4,
  className: "st2",
  width: 24.4,
  height: 0.2
}), React.createElement("rect", {
  x: 65.4,
  y: 70.6,
  className: "st2",
  width: 0.5,
  height: 17.6
}), React.createElement("path", {
  className: "st2",
  d: "M65.9,70.4h-0.4c0,0,0,0,0,0v0.2h0.5V70.4z"
}), React.createElement("path", {
  className: "st2",
  d: "M65.4,70.4L65.4,70.4C65.4,70.4,65.4,70.4,65.4,70.4L65.4,70.4z"
}), React.createElement("rect", {
  x: 12.4,
  y: 95.8,
  className: "st1",
  width: 8.2,
  height: 4.1
}), React.createElement("rect", {
  x: 81.9,
  y: 95.8,
  className: "st1",
  width: 8.2,
  height: 4.1
}), React.createElement("rect", {
  x: 47.7,
  y: 95.8,
  className: "st1",
  width: 8.2,
  height: 4.1
}), React.createElement("path", {
  className: "st1",
  d: "M12.3,93.7h9.3c0.1,0,0.2,0,0.3,0.1h24.5c0.1,0,0.2-0.1,0.3-0.1h10.2c0.1,0,0.2,0,0.3,0.1h23.4 c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0h9.5v-3.5H12.3V93.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M12.3,93.7L12.3,93.7l9.6,0.1c-0.1,0-0.2-0.1-0.3-0.1H12.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M80.9,93.7c-0.1,0-0.2,0-0.3,0.1h9.9v-0.1L80.9,93.7C80.9,93.7,80.9,93.7,80.9,93.7z"
}), React.createElement("path", {
  className: "st3",
  d: "M92.4,69.6v-0.2V49.8V30.1c0-0.6-0.4-1-1-1H64.9h-0.4H38.2H38c0,0,0,0,0,0c0,0,0,0,0,0H11.3c-0.6,0-1,0.4-1,1 v19.8c0,0,0,0,0,0c0,0,0,0,0,0v19.5v0.2v19.6c0,0,0,0,0,0c0,0,0,0,0,0v5.6c0,0.1,0,0.3,0.1,0.4v5.7c0,0.6,0.4,1,1,1h10.2 c0.6,0,1-0.5,1-1v-5.1h23.2v5.1c0,0.6,0.4,1,1,1h10.2c0.6,0,1-0.5,1-1v-5.1h22v5.1c0,0.6,0.5,1,1,1h10.2c0.6,0,1-0.5,1-1v-5.4 c0.2-0.2,0.3-0.4,0.4-0.7v-5.6c0,0,0,0,0,0c0-0.2,0-0.3-0.1-0.4V69.6z M65.4,31.1h0.5h24.4v17.8H65.9h-0.5V31.1z M65.4,50.8h0.5 h24.4v17.6H65.9h-0.5V50.8z M65.4,70.6v-0.2v0h0h0.4h24.4v0.2v17.6H65.9h-0.5V70.6z M39,31.1h0.2h24.2v17.8H39.2H39V31.1z  M39,50.8h0.3h24.2v17.6H39.2H39V50.8z M39,70.6v-0.2h0.2h24.2v0.2v17.6H39.2H39V70.6z M12.3,31.1H37v17.8H12.3V31.1z M12.3,50.8 H37v17.6H12.3V50.8z M12.3,70.6v-0.2H37v0.2v17.6H12.3V70.6z M20.6,99.9h-8.2v-4.1h8.2V99.9z M55.9,99.9h-8.2v-4.1h8.2V99.9z  M90.1,99.9h-8.2v-4.1h8.2V99.9z M90.5,93.7L90.5,93.7l-9.9,0.1H57.2H46.4H21.9h-9.6v-0.1v-3.5h78.2V93.7z"
})), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st4",
  d: "M121,78l0.8,8.2c0.1,0.9,0.7,1.7,1.6,2c10.6,3.3,21.1,5,31.5,5.1c0.5,0,0.9-0.4,0.9-1c0-0.4-0.1-0.9-0.1-1.3 c0-9,7.3-16.3,16.3-16.3s16.3,7.3,16.3,16.3c0,0.5,0,1-0.1,1.5c0,0.5,0.4,1,0.9,1l113.7,0.4c0.4,0,0.7-0.4,0.7-0.8 c-0.1-0.7-0.1-1.3-0.1-2c0-9,7.3-16.3,16.3-16.3c8.8,0,16.1,7.1,16.3,15.9c0,0.6,0,1.1,0,1.7c0,0.4,0.3,0.8,0.8,0.7 c3.7-0.5,7-1.1,8.7-2.8c0.6-0.5,0.9-1.3,0.9-2.1v-7.1c0-0.5-0.2-1-0.5-1.4l-0.6-0.8c-0.2-0.3-0.3-0.7-0.4-1 c-0.1-3.2-0.2-6.4-1-9.3c-0.3-1.3-1.1-2.5-2.2-3.3c-4.5-3.6-12.2-6.5-19.8-9.3c-1.4-0.5-2.7-1.4-3.8-2.5 c-14-15-26.6-26.7-36.9-32.3c-4.4-2.4-9.3-3.6-14.3-3.6h-134c-1.8,0-3.5,0.9-4.5,2.3c-3.7,5.3-5.7,18.6-6.8,35.9 c-0.1,1-0.1,2-0.1,3v18.1c0,0.2-0.1,0.3-0.3,0.4l0,0C121.2,77.2,121,77.6,121,78z M271.9,32.2c4,0,8,0.4,11.9,1 c1.4,0.2,2.8,0.9,3.9,1.8c4.9,4.2,10.3,9.4,16.3,15.6c1,1.1,1.5,2.6,1.2,4.1l-0.3,1.5c-0.3,1.4-1.6,2.4-3.1,2.2 c-9.3-1.2-18.1-2.7-26.1-4.8c-1.6-0.4-3-1.6-3.6-3.1c-1.5-3.5-2.3-8.9-2.6-15.9C269.6,33.3,270.6,32.2,271.9,32.2z"
})), React.createElement("path", {
  className: "st5",
  d: "M159.2,90c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13c0-7.2-5.8-13-13-13C165,77,159.2,82.8,159.2,90z M166.5,90 c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.6,5.7,5.7s-2.6,5.7-5.7,5.7C169,95.7,166.5,93.1,166.5,90z"
}), React.createElement("path", {
  className: "st5",
  d: "M307,90c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13c0-7.2-5.8-13-13-13C312.8,77,307,82.8,307,90z M314.2,90 c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.6,5.7,5.7s-2.6,5.7-5.7,5.7C316.8,95.7,314.2,93.1,314.2,90z"
}), React.createElement("line", {
  className: "st6",
  x1: 275.8,
  y1: 60.3,
  x2: 275.8,
  y2: 66.2
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st3",
  d: "M146.6,85.7c0.2-2.7,0.9-5.4,1.8-8c1-2.6,2.3-5.1,4-7.3c1.7-2.2,3.9-4.2,6.4-5.6c2.5-1.4,5.3-2.3,8.1-2.7 c1.4-0.2,2.9-0.2,4.3-0.2c0.7,0,1.4,0,2.1,0.1c0.7,0,1.4,0.1,2.1,0.2c2.8,0.4,5.6,1.2,8.1,2.5c5.1,2.6,9,7.8,9.2,13.4 c-1.8-5.2-5.7-9-10.4-11c-1.2-0.5-2.4-0.9-3.6-1.2c-1.2-0.3-2.5-0.6-3.8-0.7c-2.6-0.3-5.2-0.5-7.7-0.2c-5.1,0.5-9.8,2.9-13.3,6.8 C150.4,75.5,148,80.5,146.6,85.7z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st3",
  d: "M334,67.8c-3.1-1.9-6.5-2.5-9.9-2.8c-1.7-0.1-3.4-0.2-5.1-0.2c-1.7,0-3.3,0.2-5,0.5c-3.2,0.6-6.3,2.1-8.9,4.2 c-2.6,2.1-4.9,4.8-6.7,7.8c0.7-3.5,2.6-6.8,5.2-9.5c2.6-2.7,6.1-4.6,9.8-5.4c1.8-0.4,3.8-0.6,5.6-0.5c1.8,0,3.7,0.3,5.5,0.7 c1.8,0.4,3.6,1,5.2,1.8C331.4,65.2,333,66.3,334,67.8z"
}));

var SvgWillCallReady = function SvgWillCallReady(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352.4 114.9",
    style: {
      enableBackground: "new 0 0 352.4 114.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWillCallReady, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WillCallReady.5d2152f8.svg";
export { ForwardRef as ReactComponent };